import { Selector, State } from "./types";
import { matchRequest } from "./utils";

function createSelector(getState: () => State): Selector {
  return {
    isAdjustCapacityRequestPending(resourceId, from, to, granularity) {
      const req = getState().find((req) =>
        matchRequest(req, resourceId, from, to, granularity),
      );

      return req ? req.request.isPending : false;
    },
    isAdjustCapacityRequestSuccess(resourceId, from, to, granularity) {
      const req = getState().find((req) =>
        matchRequest(req, resourceId, from, to, granularity),
      );

      return req ? req.request.isSuccessful : false;
    },
    isAdjustCapacityRequestFailure(resourceId, from, to, granularity) {
      const req = getState().find((req) =>
        matchRequest(req, resourceId, from, to, granularity),
      );

      return req ? req.request.isFailure : false;
    },
  };
}

export { createSelector };
